export default {
  en: 'English',
  id: 'Indonesian',
  my: 'Malaysian',
  th: 'Thai',
};
